import React from "react";

import {
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box,
  Button,
  CircularProgress
} from "@mui/material";


import {
  InsertChart,
  Whatshot,
} from "@mui/icons-material";


import {
  BarChart,
} from "recharts";

import useAxios from '../../hooks/useAxios';
import { useEffect, useState } from 'react';
import Navbar from "../LandingV2/Navbar";
import HeatMap from "./HeatMap";
import StockInsights from "./StockInsights";
import PortfolioOverview from "./PortfolioOverview";
import { useExternalLink } from "../../hooks/useExternalLink";
import Trade from "./Trade/Trade";
import { useSelector } from "react-redux";
import StrategyChatBot from "./StrategyBot/StrategyChatBot";
import SellStocks from "./SellStocks.js/SellStocks";

function TabPanel({ value, index, children }) {
  return value === index && <Box sx={{ p: 3 }}>{children}</Box>;
}

const kiteLogoUrl = "/assets/images/zerodha-kite-logo-png_seeklogo-487028.png";


const PersonalInsights = () => {
  const s3FetchURL = `${process.env.REACT_APP_S3_TRADE_FETCH_URL}`
  const heatMapKEY = `${process.env.REACT_APP_S3_TRADE_FETCH_KEY}/heatmap_data.json`;
  const portFolioMetricsKEY = `${process.env.REACT_APP_S3_TRADE_FETCH_KEY}/portfolio_data.json`;
  const historicalDataKEY = `${process.env.REACT_APP_S3_TRADE_FETCH_KEY}/historical_data.json`;
  const overdueDataKEY = `${process.env.REACT_APP_S3_TRADE_FETCH_KEY}/stocks-to-sell/files-generated/portfolio_analysis_complete.json`;
  const tradeHealthURL = `${process.env.REACT_APP_APP_TRADE_HEALTH_URL}/health`;

  const [tab, setTab] = React.useState(0);
  const [portfolioMetrics, setPortFolioMetrics] = useState({});
  const [portfolioSectors, setPortFolioSectors] = useState([]);
  const [portfolioHoldings, setPortFolioHoldings] = useState([]);
  const [heatMapData, setHeatMapData] = useState([]);
  const [historicalData, setHistoricalData] = useState([]);
  const [overdueData, setOverdueData] = useState({});
  const [healthData, setHealthData] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user_authentication.token);
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const openKite = useExternalLink("https://kite.zerodha.com/");

  const {
    data: getPortFolioMetrics,
    error: errorPortFolioMetrics,
    loading: loadedPortFolioMetrics,
    callAPI: callAPIPortfolioMetrics
  } = useAxios();


  const {
    data: getHeatMap,
    error: errorHeatMap,
    loading: loadedHeatMap,
    callAPI: callAPIHeatMap
  } = useAxios();

  const {
    data: getHistoricalData,
    error: errorHistoricalData,
    loading: loadedHistoricalData,
    callAPI: callAPIHistoricalData
  } = useAxios();

  const {
    data: getOverdueData,
    error: errorOverdueData,
    loading: loadingOverdueData,
    callAPI: callAPIOverdueData
  } = useAxios();

  const {
    data: getHealthData,
    error: errorHealthData,
    loading: loadedHealthData,
    callAPI: callAPIHealthData
  } = useAxios();


  useEffect(() => {
    if (getHealthData) {
      setLoading(false);
      setHealthData(getHealthData);
      setIsActive(getHealthData.services?.trading_api === "healthy");
      console.log('getHealthData ', getHealthData);
    } else if (loadedHealthData && errorHealthData) {
      console.error(errorHealthData);
      setLoading(false);
    }
  }, ([loadedHealthData, errorHealthData, getHealthData]));


  const getRandomColor = () =>
    '#' + Array.from({ length: 6 }, () => '0123456789ABCDEF'[Math.floor(Math.random() * 16)]).join('');

  useEffect(() => {
    if (loadedHistoricalData && getHistoricalData) {
      console.log('calling getHistoricalData', getHistoricalData);
      setHistoricalData(getHistoricalData.data["data"]);
    } else if (loadedHistoricalData && errorHistoricalData) {
      console.log('errorHeatMap error', errorHeatMap);
    }
  }, ([getHistoricalData, errorHistoricalData, loadedHistoricalData]));

  useEffect(() => {
    if (loadedHeatMap && getHeatMap) {
      setHeatMapData(getHeatMap.data["data"]);
    } else if (loadedHeatMap && errorHeatMap) {
      console.log('errorHeatMap error', errorHeatMap);
    }
  }, ([loadedHeatMap, getHeatMap, errorHeatMap]));



  useEffect(() => {
    if (loadingOverdueData && getOverdueData) {
      console.log('calling getOverdueData', getOverdueData);
      console.log('calling getOverdueData', getOverdueData["data"]);
      setOverdueData(getOverdueData["data"]);
    } else if (loadingOverdueData && errorOverdueData) {
      console.log('errorHeatMap error', errorOverdueData);
    }
  }, ([loadingOverdueData, getOverdueData, errorOverdueData]));

  useEffect(() => {
    if (getPortFolioMetrics && loadedPortFolioMetrics) {
      console.log(getPortFolioMetrics);
      console.log(typeof getPortFolioMetrics);
      console.log(getPortFolioMetrics["metrics"]);
      console.log(getPortFolioMetrics.data.metrics);
      setPortFolioMetrics(getPortFolioMetrics.data["metrics"]);
      const coloredSectors = getPortFolioMetrics.data["sectors"].map(sector => ({
        ...sector,
        color: getRandomColor()
      }));
      setPortFolioSectors(coloredSectors);
      setPortFolioHoldings(getPortFolioMetrics.data["holdings"]);
    } else if (loadedPortFolioMetrics && errorPortFolioMetrics) {
      console.log('getPortFolioMetrics error', errorPortFolioMetrics);
    }
  }, ([getPortFolioMetrics, errorPortFolioMetrics, loadedPortFolioMetrics]));




  useEffect(() => {
    callAPIPortfolioMetrics(
      s3FetchURL,
      "POST",
      { "s3_location": portFolioMetricsKEY },
      {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    );
    callAPIHeatMap(
      s3FetchURL,
      "POST",
      { "s3_location": heatMapKEY },
      {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    );
    callAPIHistoricalData(
      s3FetchURL,
      "POST",
      { "s3_location": historicalDataKEY },
      {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    );
    callAPIOverdueData(
      s3FetchURL,
      "POST",
      { "s3_location": overdueDataKEY },
      {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    );
    callAPIHealthData(
      tradeHealthURL,
      "GET",
      null,
      {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    )
  }, []);

  return (
    <>
      <Navbar />
      <Box sx={{ bgcolor: "white", color: "#2d4890", minHeight: "100vh", p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h4" sx={{ display: "flex", alignItems: "center" }}>
            <InsertChart sx={{ mr: 1 }} />
            Stock Portfolio Analysis
          </Typography>

          <Box textAlign="right">
            <Typography variant="body2" color={isActive ? "green" : "text.secondary"}>
              Status: {isActive ? "Active" : "Inactive"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Last updated: {healthData.timestamp}
            </Typography>

            {!isActive && (
              <Button
                variant="contained"
                onClick={openKite}
                sx={{
                  mt: 1,
                  backgroundColor: "#fff",
                  "&:hover": { backgroundColor: "#fff" },
                  color: "#2d4890",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={kiteLogoUrl}
                  alt="Kite Logo"
                  style={{ width: 24, height: 24, marginRight: 8 }}
                />
                Activate Kite Account
              </Button>
            )}
          </Box>
        </Box>

        {loading && (
          <Box
            position="absolute"
            top={350}
            left={0}
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            zIndex={1000}
            bgcolor="rgba(255, 255, 255, 0.6)"
          >
            <CircularProgress size={40} />
          </Box>
        )}

        <AppBar position="static" color="default" sx={{ background: "white" }}>
          <Tabs value={tab} onChange={handleChange} variant="scrollable" scrollButtons="auto">
            <Tab label="Portfolio Overview" />
            <Tab label="Heatmaps" icon={<Whatshot />} iconPosition="start" />
            <Tab label="Stock Analysis" icon={<BarChart />} iconPosition="start" />
            <Tab label="Trade" icon={<BarChart />} iconPosition="start" />
            <Tab label="Divest Portfolio (Bulk)  📉" iconPosition="start" />
            <Tab label="Strategy Bot 🤖" iconPosition="start" />
          </Tabs>
        </AppBar>

        <TabPanel value={tab} index={0}>
          <PortfolioOverview holdings={portfolioHoldings} metrics={portfolioMetrics} sectors={portfolioSectors} />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <HeatMap data={heatMapData} />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <StockInsights stockData={portfolioHoldings} historicalData={historicalData} />
        </TabPanel>
        <TabPanel value={tab} index={3}>
          <Trade stockData={portfolioHoldings} />
        </TabPanel>
        <TabPanel value={tab} index={4}>
          <SellStocks holdings={portfolioHoldings}  dueHoldings={overdueData}/>
        </TabPanel>
        <TabPanel value={tab} index={5}>
          <StrategyChatBot stockData={portfolioHoldings} />
        </TabPanel>
      </Box>
    </>
  );
}
export default PersonalInsights;